<template>
  <div class="downloadbox">
    <div class="fallDown">
      <div class="fallDown-left">
        <div class="left-header">
          <img src="@/assets/images/winterlogo.png" alt="" />
        </div>
        <h1>{{fallRule.title}}</h1>
        <ul>
          <li v-for="(item,index) in fallRule.cont" :key='index'>{{item}}</li>
        </ul>
        <div class="left-footer">
          <span @click="dialogVisible('apply')">适用范围</span>
          <span @click="dialogVisible('installation')">安装说明</span>
        </div>
      </div>
      <div class="fallDown-right">
        <div class="right-header">
          <p>
            <b class="big">最新版本：</b>当前展示{{ count }}个，一共{{
              total
            }}个
          </p>
          <div class="block">
            <b class="big">版本更新时间：</b>
            <el-date-picker
              v-model="deviceFormData.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              :picker-options="pickerOptions"
              @blur="search"
              :clearable="false"
            >
            </el-date-picker>
          </div>
        </div>

        <div class="right-cont" v-if="listdata && listdata.length > 0">
          <div
            v-for="(item, index) in listdata"
            class="right-item"
            :key="index"
          >
            <span v-if="item.is_new && item.is_new == true" class="recommend"
              >推荐</span
            >
            <el-radio-group v-model="radio" text-color>
              <el-radio :label="index">
                <span class="bold"> {{ item.version }}版本 </span>
                <span>({{ item.size | size }})</span>
                <p class="md5">MD5:{{ item.md5 }}</p>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="right-cont-nodata" v-else>暂无数据</div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page.sync="currentPage"
            :small="true"
            :page-size="9"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <div class="right-footer">
          <el-tooltip v-if="radio === ''" placement="top">
            <div slot="content">请选择需要下载的离线包</div>
            <p><el-button :disabled="radio === ''">本地下载</el-button></p>
          </el-tooltip>
          <el-button v-if="radio !== ''" @click="down('local')"
            >本地下载</el-button
          >
          <p>
            <el-button type="primary" @click="down('key')">密钥下载</el-button>
            <el-tooltip placement="top">
              <div slot="content">
                1、您需要先登录，才能获取密钥。密钥数据展示在您的用户基本信息页面。<br />2、我们会将使用密钥下载说明发送到您的注册邮箱。<br />3、您可以根据提供的密钥及接口地址，自动请求获取当前离线资源包。
              </div>
              <img src="@/assets/images/warning.png" alt="" />
            </el-tooltip>
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      :title="centerTitle"
      :visible.sync="centerDialogVisible"
      width="45%"
      center
    >
      <div class="riledialog">
        <span v-html="dialogcont"></span>
        <el-button @click="centerDialogVisible = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { User } from '@/api/api.js';
import { tipDialogtext } from '@/utils/helper.js';
import { fallRule } from '@/config';

export default {
  name: '',
  data () {
    return {
      count: 0,
      total: 0,
      dialog: false,
      currentPage: 1,
      listdata: [],
      radio: '',
      dialogcont: '',
      centerDialogVisible: false,
      dialogFormVisible: false,
      logtoken: true,
      userall: true,
      useremail: '',
      choiceDate0: '',
      dialogVisibleShow: true,
      pickerOptions: {
        // 设置不能选择的日期
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          let choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 1
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 1
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (this.choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        }
      },
      centerTitle: '',
      deviceFormData: {
        time: []
      },
      fallRule: fallRule
    };
  },
  filters: {
    size (value) {
      return (value / (1024 * 1024)).toFixed(2) + 'M';
    }
  },
  components: {
  },
  watch: {
    'deviceFormData.time' (newVal) {
      if (newVal == null) {
        this.deviceFormData.time = [];
      }
    }
  },
  methods: {
    down (type) {
      this.userInfoisall(false);
      if (!this.logtoken) {
        this.$message.error('用户未登录，请先登录');
      } else if (!this.userall) {
        this.$message.error('请先完善基本信息');
        setTimeout(() => {
          this.dialogFormVisible = true;
        }, 500);
      } else if (type === 'local') {
        const a = document.createElement('a'); // 创建a标签
        a.setAttribute('download', ''); // download属性
        a.setAttribute('href', this.listdata[this.radio].url); // href链接
        console.log(this.listdata[this.radio].url, 'url');
        a.click(); // 自执行点击事件
      } else {
        this.userInfoisall(true, 'stix2_public');
        setTimeout(() => {
          this.dialogVisible('application');
        }, 1000);
      }
    },

    // 设置默认时间
    getTimeFn () {
      const that = this;
      const start = new Date(new Date().getTime() - 6 * 24 * 3600 * 1000);
      const end = new Date();
      that.deviceFormData.time[0] = start;
      that.deviceFormData.time[1] = end;
    },

    dialogVisible (type) {
      if (this.dialogVisibleShow) {
        this.centerDialogVisible = true;
        this.centerTitle = tipDialogtext[type].title;
        this.dialogcont = tipDialogtext[type].content({
          email: this.useremail
        });
      }
    },
    getListdata (defaultpage) {
      let startTime = this.deviceFormData.time[0]
        .setHours(0, 0, 0)
        .toString()
        .slice(0, 10);
      let endTime = this.deviceFormData.time[1]
        .setHours(23, 59, 59)
        .toString()
        .slice(0, 10);
      let data = {
        page: defaultpage,
        page_size: 9,
        build_start_time: startTime,
        build_end_time: endTime,
        category: 'stix2_public'
      };
      User.getPackagelist(data).then((res) => {
        try {
          this.total = res.data.total || 0;
          this.listdata = res.data.packages;
          this.count = res.data.packages.length;
        } catch (e) {
          this.total = 0;
          this.listdata = [];
          this.count = 0;
        }
      });
    },
    search () {
      this.radio = '';
      this.currentPage = 1;
      this.getListdata(1);
    },
    handleCurrentChange (val) {
      this.radio = '';
      this.getListdata(val);
    },
    // 用户信息是否完善
    userInfoisall (type, down) {
      let params = {}

      if (down) {
        console.log('down:', down);
        params = {
          send_email: type,
          category: down
        };
      } else {
        params = {
          send_email: type
        };
      }

      User.getUserInfo(params).then(({ data }) => {
        if (data.status === 10000) {
          this.useremail = data.data.email;
          if (
            data.data.company &&
            data.data.realname &&
            data.data.phone &&
            data.data.email
          ) {
            this.userall = true;
          } else {
            this.userall = false;
          }
        } else if (data.status === 10001) {
          this.logtoken = false;
        } else if (data.status === 10004) {
          this.$message.error(data.message);
          this.dialogVisibleShow = false;
        }
      });
    }
  },
  created () {
    this.getTimeFn();
    this.getListdata(this.currentPage);
    this.userInfoisall(false);
  }
};
</script>

<style lang='scss' scoped>

.fallDown {
  display: flex;
  height: 480px;
}

.fallDown-left {
  flex: 1;
  color: #fff;
  background: #4473f6;
  .left-header img {
    width: 115px;
    height: 58px;
  }
  h1 {
    font-size: 18px;
    text-align: center;
    margin: 25px 0;
  }
  ul {
    padding: 0 15px;
    font-weight: 500;
    li {
      line-height: 36px;
      font-size: 14px;
    }
  }
}
.fallDown-right {
  flex: 4;
  background: #fff;
  .right-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 30px 20px 25px;
  }
  .right-cont {
    display: flex;
    flex-wrap: wrap;
    gap: 1.9%;
    padding-left: 30px;
    height: 230px;
    .right-item {
      width: 32%;
      padding: 15px 0 0 0;
      position: relative;
    }
    .recommend {
      position: absolute;
      top: 11px;
      right: 5%;
      color: #fff;
      font-size: 12px;
      display: inline-block;
      background: #4473f6;
      padding: 3px;
      border-radius: 5px;
    }
  }
  .right-cont2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.right-cont-nodata {
  height: 230px;
  text-align: center;
  padding: 40px;
}
.pagination {
  padding: 30px 60px 0 0;
  text-align: right;
}
.left-footer {
  margin-top: 18%;
  display: flex;
  justify-content: space-around;
  span {
    border-bottom: 1px solid #fff;
    font-size: 15px;
  }
}
/deep/.el-radio__inner::after {
  width: 14.5px;
  height: 14.5px;
  background-image: url(~@/assets/images/selected.png);
  background-size: cover;
  border: 0;
}
.md5 {
  margin-left: 27px;
  margin-top: 8px;
  font-size: 12px;
}

.bold {
  font-weight: 900;
}
.big {
  font-size: 18px;
}
.el-button--default {
  color: #4473f6;
  border: 1px solid #4473f6;
}
.el-button--primary {
  background: #4473f6;
}
.right-footer {
  margin-top: 4%;
  display: flex;
  justify-content: space-around;
}
.el-button {
  margin: 0 10px 0 0;
  padding: 10px 80px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #000;
}
/deep/ .el-dialog__body {
  color: #000;
  line-height: 25px;
}
/deep/.el-dialog__title {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}
/deep/.el-dialog__header {
  text-align: left;
  background: #4473f6;
  padding: 10px 25px;
}
/deep/.el-dialog__headerbtn {
  top: 13px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
.riledialog {
  position: relative;
  .el-button {
    padding: 10px 20px;
    margin-left: 85%;
    margin-top: 20px;
  }
}
</style>
